import EnrollmentValidationDebugFilterEvaluation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentValidationDebugFilterEvaluation';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const PersistedReEnrollmentListDebugFilterRenderer = ({
  matchResults,
  flowRevision
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    as: "div",
    children: matchResults.map(result => /*#__PURE__*/_jsx(EnrollmentValidationDebugFilterEvaluation, {
      listId: result.listId,
      evaluationResult: result.debugFilterBranch,
      flowRevision: flowRevision
    }, result.listId))
  });
};
export default PersistedReEnrollmentListDebugFilterRenderer;